import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/faqs";
import { Placeholderize } from "./Section";

export const FAQList = ({ items = FAQS, prefix = "faq" }) => (
  <Accordion type="single" collapsible className="divide-y divide-[#1f1f1f] border-y border-[#1f1f1f]" data-testid={`${prefix}-list`}>
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`item-${i}`} className="border-0">
        <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold hover:no-underline hover:text-[#FF6A00] [&>svg]:text-[#FF6A00]" data-testid={`${prefix}-trigger-${i}`}>
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-6 pr-8 text-[15px] leading-relaxed text-[#A1A1AA]">
          <Placeholderize text={f.a} />
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
